<template>
    <v-layout row wrap pa-2>
        <v-flex xs12 sm6 lg3 px-1 pt-1> 
            <v-autocomplete :items="plants" v-model="selectedPlant" box chips clearable hide-details dense outline
                item-text="PlantName" item-value="PlantID" label="Plant" placeholder="Plant"
            ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 lg3 px-1 pt-1> 
            <v-autocomplete v-if="selectedPlant" :items="productCategories" v-model="selectedProductCategory" box chips clearable hide-details dense outline
                item-text="ProductCategoryName" item-value="ProductCategoryID" label="Category" placeholder="Category"
            ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 lg3 px-1 pt-1> 
            <v-autocomplete v-if="selectedProductCategory && selectedPlant" :items="divisions" v-model="selectedDivision" box chips clearable hide-details dense outline
                item-text="DivisionName" item-value="DivisionID" label="Division" placeholder="Division"
            ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 lg3 px-1 pt-1> 
                <v-autocomplete v-if="selectedProductCategory && selectedPlant" :items="locations" v-model="selectedLocation" box chips clearable hide-details dense outline
                item-text="LocationName" item-value="LocationID" label="Location" placeholder="Location"
            ></v-autocomplete>
        </v-flex>
    </v-layout>
</template>

<script>

export default {
    data() {
        return {
            
        }
    },
    props: [
        
    ],
    components: {

    },
    computed: {
        selectedPlant: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedPlant;
            },
            set(value) {
                this.$store.commit("PestAndDiseaseStore/setSelectedPlant", value);
            }
        },
        selectedProductCategory: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedProductCategory;
            },
            set(value) {
                this.$store.commit("PestAndDiseaseStore/setSelectedProductCategory", value);
            }
        },
        selectedDivision: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedDivision;
            },
            set(value) {
                this.$store.commit("PestAndDiseaseStore/setSelectedDivision", value);
            }
        },
        selectedLocation: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedLocation;
            },
            set(value) {
                this.$store.commit("PestAndDiseaseStore/setSelectedLocation", value);
            }
        },
        plants() {
            return this.$store.getters["PestAndDiseaseStore/getPlants"];
        },
        productCategories() {
            return this.$store.getters["PestAndDiseaseStore/getFilteredProductCategories"];
        },
        divisions() {
            return this.$store.getters["PestAndDiseaseStore/getFilteredDivisions"];
        },
        locations() {
            return this.$store.getters["PestAndDiseaseStore/getFilteredLocations"];
        }
    },
    methods: {
        
    },
    async created() {
        // select the current user's default plant if no plant has been selected, if available
        if (!this.selectedPlant) {            
            this.selectedPlant = this.$store.getters["UserStore/primaryPlantID"];

            if (this.plants.length === 1) {
                this.selectedPlant = this.plants[0].PlantID;
            }
        }
    }
}
</script>

<style>

</style>
